import { render } from "./CreateChatbotModal.vue?vue&type=template&id=b369a754&scoped=true"
import script from "./CreateChatbotModal.vue?vue&type=script&lang=js"
export * from "./CreateChatbotModal.vue?vue&type=script&lang=js"

import "./CreateChatbotModal.vue?vue&type=style&index=0&id=b369a754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b369a754"]])

export default __exports__